module.exports = __webpack_public_path__ + "img/9.ed04cd06.jpg";